import React from 'react';
import { observer } from 'mobx-react-lite';

const StatisticsItem = observer(({ color, percentage }) => {
  return (
    <div className='m-game-row-stat'>
      {/* <div className='m-game-row-stat-item left'>
        <span className='m-game-row-stat-item-sp'>{number}.</span>
      </div> */}
      <div className='m-game-row-stat-item center'>
        <div className={`mob-st-circle ${color}`} />
      </div>
      <div className='m-game-row-stat-item right'>
        <div className='m-game-line-con'>
          <div className='m-game-line-h'>
            <div className={`m-game-line-ins ${color}`} style={{ maxWidth: `${percentage}%` }} />
          </div>
        </div>
      </div>
      <div className='m-game-row-stat-item result'>
        <span className='m-game-statistic-result-sp'>{`${percentage}%`}</span>
      </div>
    </div>
  );
});

export default StatisticsItem;
